import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'no-component',
  templateUrl: './no-component.component.html',
  styleUrls: ['./no-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class NoComponentComponent{
}